import React, { FunctionComponent } from 'react';
import { Trans } from 'react-i18next';
import { TabType } from './AdminTabs';

export type Props = {
  type: TabType;
  onClick?: () => void;
  link?: string;
  isActive?: boolean;
};

const Tab: FunctionComponent<Props> = ({ isActive, type, onClick, link }) => (
  <li
    className={`jg-space-mtms jg-space-mhsm@md jg-space-pbsm jg-space-pln${
      isActive ? ' jg-tc-admin-tabs--active' : ''
    }`}
  >
    <a
      href={link}
      onClick={onClick}
      className="jg-space-phsm jg-text--large-regular"
    >
      <Trans i18nKey={`content.admintabs.${type}`} />
    </a>
  </li>
);

export default Tab;
